import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SuspendedMeasureIconComponent } from '../../../../../ui/suspended-measure-icon/suspended-measure-icon.component';
import { MeasureGridRow } from './campaign-measures-grid.service';

@Component({
  selector: 'app-measure-name-cell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SuspendedMeasureIconComponent],
  styles: [':host { display: inline-flex; align-items: center; gap: 6px; }'],
  template: `
    @if (data()?.isInactive ?? false) {
      <ces-suspended-measure-icon [tooltip]="tooltip()" />
    }
    <span>{{ value() }}</span>
  `,
})
export class MeasureNameCellComponent implements ICellRendererAngularComp {
  private readonly translate = inject(TranslocoService);

  protected readonly data = signal<MeasureGridRow | undefined>(undefined);
  protected readonly value = signal<string>('');

  protected readonly tooltip = computed(() => this.translate.translate('entities.campaign.grid.measureInactiveTooltip'));

  agInit(params: ICellRendererParams<MeasureGridRow, string>): void {
    this.data.set(params.data);
    this.value.set(params.value ?? '');
  }

  refresh(params: ICellRendererParams<MeasureGridRow, string>): boolean {
    this.data.set(params.data);
    this.value.set(params.value ?? '');
    return true;
  }
}
